import { Helmet } from "react-helmet-async";

// Default SEO wrapper. Pass title, description, path.
export default function Seo({ title, description, path = "/", jsonLd }) {
  const fullTitle = title
    ? `${title} — SKVY Harmony Placement`
    : "SKVY Harmony Placement — AI-Powered US IT Staffing";
  const desc =
    description ||
    "SKVY Harmony Placement places international students, OPT, CPT and H-1B professionals into US tech roles across software, data, AI, cloud and cybersecurity.";
  const url = `https://skvyharmonyplacement.com${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
